import { render } from "./Huawei.vue?vue&type=template&id=b6ed6616"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Huawei.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6ed6616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6ed6616', __exports__)) {
    api.reload('b6ed6616', __exports__)
  }
  
  module.hot.accept("./Huawei.vue?vue&type=template&id=b6ed6616", () => {
    api.rerender('b6ed6616', render)
  })

}


export default __exports__